/**
 * I18n Store
 *
 * Zustand store definition for internationalization state.
 *
 * @module @store/i18n/i18nStore
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import {
    DEFAULT_LANGUAGE,
    SUPPORTED_LANGUAGES,
} from '@shared/i18n/constants/languages';
import type { I18nStore } from './i18nTypes';
import { checkDevEnv } from '@shared/utils/env';
import { createI18nActions } from './i18nActions';

const initialState = {
    language: DEFAULT_LANGUAGE,
    translations: {
        [SUPPORTED_LANGUAGES.NB]: {},
        [SUPPORTED_LANGUAGES.NN]: {},
        [SUPPORTED_LANGUAGES.EN_GB]: {},
    },
    isLoading: false,
    error: null,
};

/**
 * Zustand store for internationalization state.
 */
export const useI18nStore = create<I18nStore>()(
    devtools(
        (set): I18nStore => ({
            ...initialState,
            ...createI18nActions(set),
        }),
        { enabled: checkDevEnv(), name: 'i18nStore' },
    ),
);
